exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2ezgvZPIQNhyW34kZKES4N{margin-bottom:20px}._2ezgvZPIQNhyW34kZKES4N ._1qMEJMA7of-wTcDU3iTb9u{padding-bottom:10px}.HajwVOk1sQkyVgu_7TvTg{display:flex;width:100%}.HajwVOk1sQkyVgu_7TvTg>div{flex:1 1 50%}.HajwVOk1sQkyVgu_7TvTg>div:first-child{padding-right:8px}.HajwVOk1sQkyVgu_7TvTg>div:last-child{padding-left:8px}._1eLDgaUgnOAfsiENSmUiO2{display:flex;align-items:center;padding-top:12px}._1eLDgaUgnOAfsiENSmUiO2 .aHQw-BLfrvNOZTaiha6eD{margin-left:14px;margin-bottom:5px}._3PWCyAMd2dBtIHL4q-v9Sg{display:flex;justify-content:space-between}._3PWCyAMd2dBtIHL4q-v9Sg ._1NqySJrt7HQ09tr0Qbflc5{display:flex;align-items:center}._3PWCyAMd2dBtIHL4q-v9Sg ._1NqySJrt7HQ09tr0Qbflc5 img{margin-top:0}._3PWCyAMd2dBtIHL4q-v9Sg ._1NqySJrt7HQ09tr0Qbflc5 .t06SliahyFCazaj7MbQA3{padding:0px 5px}\n", ""]);

// Exports
exports.locals = {
	"switcherIntro": "_2ezgvZPIQNhyW34kZKES4N",
	"firstMsg": "_1qMEJMA7of-wTcDU3iTb9u",
	"twoCol": "HajwVOk1sQkyVgu_7TvTg",
	"inlineCB": "_1eLDgaUgnOAfsiENSmUiO2",
	"cbInline": "aHQw-BLfrvNOZTaiha6eD",
	"FlagButton": "_3PWCyAMd2dBtIHL4q-v9Sg",
	"flag": "_1NqySJrt7HQ09tr0Qbflc5",
	"spacer": "t06SliahyFCazaj7MbQA3"
};